import {FC, useEffect, useRef} from 'react';
import {waitUntil} from '../utils/waitUntil';
import {BasPromotionMonitoring, usePromotionTracking} from './TrackPromotions';

/**
 * ASFE-3146 - triggers the promotion impression event for BAS placement reserved spaces
 *
 * @returns null
 */
export const TrackBASMonitoring: FC<{
  basPromotionSource: BasPromotionMonitoring['originalSource'];
}> = ({basPromotionSource}) => {
  const wasTracked = useRef(false);
  const track = useTrackBASMonitoring(basPromotionSource);

  // eslint-disable-next-line local-rules/too-complex-useeffects
  useEffect(() => {
    const {waiter, cancel} = waitUntil(() =>
      window.dataLayer.some(
        (item: any) =>
          item.event === 'contentView' || item.event === 'content_view',
      ),
    );

    if (!wasTracked.current) {
      waiter.then(() => {
        track('impression');
        wasTracked.current = true;
      });
    }

    return () => {
      cancel();
    };
  }, []);

  return null;
};

export const useTrackBASMonitoring = (
  originalSource: BasPromotionMonitoring['originalSource'],
) =>
  usePromotionTracking({
    promotion: {
      source: 'monitoring',
      originalSource,
      advertisement: {
        id: 'monitoring',
        name: 'monitoring',
      },
    },
    streamPosition: 0,
  });
